import {html, css, LitElement, nothing} from 'lit';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';

class KeliPanelMenuItem extends ScopeBinding(LitElement) {
  static styles = css`
      :host {
          display: block;
          padding: .5em 0;
          cursor: pointer;
      }

      :host(.hidden) {
          display: none;
      }

      .caption {
          display: block;
          font-size: .5em;
          text-transform: uppercase;
          margin-top: -3px;
      }

      sl-icon {
          font-size: 22px;
      }
  `;

  static keliControlTypes = ['menuroot'];
  static properties = {
    keliname: {type: String},
    caption: {type: String},
    visible: {type: Boolean, scopeVar: 'vis'},
    icon: {type: String}
  };

  render() {
    return html`
        <sl-icon name="${KeliInterface.Styles.parseIconName(this.icon)}"></sl-icon>
        <span class="caption">${this.caption}</span>
    `;
  }

  updated(changedProperties) {
    super.updated(changedProperties);

    for (const property of changedProperties.keys()) {
      if (this[`${property}Changed`]) {
        this[`${property}Changed`](this[property]);
      }
    }
  }

  visibleChanged(newValue) {
    this.classList.toggle('hidden', (newValue === false));
  }
}

customElements.define('keli-panel-menu-section', KeliPanelMenuItem);